/*! JointJS+ v4.0.1 - HTML5 Diagramming Framework

Copyright (c) 2024 client IO

 2024-04-11 


This Source Code Form is subject to the terms of the JointJS+ License
, v. 2.0. If a copy of the JointJS+ License was not distributed with this
file, You can obtain one at https://www.jointjs.com/license
 or from the JointJS+ archive as was distributed by client IO. See the LICENSE file.*/


import { dia, mvc, shapes } from '@joint/plus';

import {
    CONDITON_ICON,
    ENTITY_ICON,
    FLOW_ICON,
    FONT_FAMILY,
    LIGHT_COLOR,
    LLM_ICON,
    MAIN_COLOR,
    MESSAGE_ICON,
    PADDING_L,
    RESPONSE_PARAM_ICON,
    TALK_ATTENDANT_ICON,
} from '../../theme';

export enum ShapeTypesEnum {
    MESSAGE = 'stencil.Message',
    FLOWCHART_START = 'stencil.FlowchartStart',
    FLOWCHART_END = 'stencil.FlowchartEnd',
    RESPONSE_ORIENTATION = 'stencil.ResponseOrientation',
    TALK_ATTENDANT = 'stencil.TalkAttendant',
    RESPONSE_PARAM = 'stencil.ResponseParam',
    SERVICE = 'stencil.Service',
    FLOW = 'stencil.Flow',
    CREATE_TICKET = 'stencil.CreateTicket',
    AVALIATION = 'stencil.Avaliation',
    LLM = 'stencil.LLM',
    CONDITION = 'stencil.Condition',
    SET_VARIABLE = 'stencil.SetVariable',
    TAG = 'stencil.Tag',
    NOTE = 'stencil.Note',
    BUSINESS_HOURS = 'stencil.BusinessHours',
    NATIVE_ACTION = 'stencil.NativeAction',
    INTERACTIVE_LIST = 'stencil.InteractiveList'
}

// Ícones base64 (MDI). Distintos pra cada caixa — regra do usuário: ícone único por tipo.
// Ícone "settings/gear" MDI pra SetVariable — fix 08/10 (antes usava CONDITON_ICON, confundia com Condition).
const SET_VARIABLE_ICON_SVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iIzMyMkE0OSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIj48cGF0aCBkPSJNMTkuNDMgMTIuOThjLjA0LS4zMi4wNy0uNjQuMDctLjk4cy0uMDMtLjY2LS4wNy0uOThsMi4xMS0xLjY1Yy4xOS0uMTUuMjQtLjQyLjEyLS42NGwtMi0zLjQ2Yy0uMTItLjIyLS4zOS0uMy0uNjEtLjIybC0yLjQ5IDFjLS41Mi0uNC0xLjA4LS43My0xLjY5LS45OGwtLjM4LTIuNjVDMTQuNDYgMi4xOCAxNC4yNSAyIDE0IDJoLTRjLS4yNSAwLS40Ni4xOC0uNDkuNDJsLS4zOCAyLjY1Yy0uNjEuMjUtMS4xNy41OS0xLjY5Ljk4bC0yLjQ5LTFjLS4yMy0uMDktLjQ5IDAtLjYxLjIybC0yIDMuNDZjLS4xMy4yMi0uMDcuNDkuMTIuNjRsMi4xMSAxLjY1Yy0uMDQuMzItLjA3LjY1LS4wNy45OHMuMDMuNjYuMDcuOThsLTIuMTEgMS42NWMtLjE5LjE1LS4yNC40Mi0uMTIuNjRsMiAzLjQ2Yy4xMi4yMi4zOS4zLjYxLjIybDIuNDktMWMuNTIuNCAxLjA4LjczIDEuNjkuOThsLjM4IDIuNjVjLjAzLjI0LjI0LjQyLjQ5LjQyaDRjLjI1IDAgLjQ2LS4xOC40OS0uNDJsLjM4LTIuNjVjLjYxLS4yNSAxLjE3LS41OSAxLjY5LS45OGwyLjQ5IDFjLjIzLjA5LjQ5IDAgLjYxLS4yMmwyLTMuNDZjLjEyLS4yMi4wNy0uNDktLjEyLS42NGwtMi4xMS0xLjY1ek0xMiAxNS41Yy0xLjkzIDAtMy41LTEuNTctMy41LTMuNXMxLjU3LTMuNSAzLjUtMy41IDMuNSAxLjU3IDMuNSAzLjUtMS41NyAzLjUtMy41IDMuNXoiLz48L3N2Zz4=';
const TAG_ICON_SVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iIzMyMkE0OSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIj48cGF0aCBkPSJNMjEuNDEgMTEuNThsLTkuMDEtOS4wMUMxMi4wNSAyLjIyIDExLjU1IDIgMTEgMkg0Yy0xLjEgMC0yIC45LTIgMnY3YzAgLjU1LjIyIDEuMDUuNTkgMS40Mmw5LjAxIDkuMDFjLjM2LjM2Ljg2LjU4IDEuNDEuNTggLjU1IDAgMS4wNS0uMjIgMS40MS0uNTlsNy04Yy4zOC0uMzcuNi0uODcuNi0xLjQyIDAtLjU1LS4yMy0xLjA2LS42LTEuNDJ6TTUuNSA3QzQuNjcgNyA0IDYuMzMgNCA1LjVTNC42NyA0IDUuNSA0IDcgNC42NyA3IDUuNSA2LjMzIDcgNS41IDd6Ii8+PC9zdmc+';
const NOTE_ICON_SVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iIzMyMkE0OSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIj48cGF0aCBkPSJNMTkgMkg1Yy0xLjEgMC0yIC45LTIgMnYxNmMwIDEuMS45IDIgMiAyaDE0YzEuMSAwIDItLjkgMi0yVjRjMC0xLjEtLjktMi0yLTJ6TTkgMTdoLTJWN2gyIHYxMHptNC01aC0ydjJoMnYzaC0yYy0xLjEgMC0yLS45LTItMlY5YzAtMS4xLjktMiAyLTJoMnY1em02LTVoLTJ2N2gydjNoLTRWN2g0djJ6Ii8+PC9zdmc+';
const BUSINESS_HOURS_ICON_SVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iIzMyMkE0OSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIj48cGF0aCBkPSJNMTEuOTkgMkM2LjQ3IDIgMiA2LjQ4IDIgMTJzNC40NyAxMCA5Ljk5IDEwQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyUzE3LjUyIDIgMTEuOTkgMnpNMTIgMjBjLTQuNDIgMC04LTMuNTgtOC04czMuNTgtOCA4LTggOCAzLjU4IDggOC0zLjU4IDgtOCA4em0uNS0xM0gxMXY2bDUuMjUgMy4xNS43NS0xLjIzLTQuNS0yLjY3eiIvPjwvc3ZnPg==';
// Ícone "bolt/flash" MDI — ação instantânea do Mexx.
const NATIVE_ACTION_ICON_SVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iIzMyMkE0OSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIj48cGF0aCBkPSJNNyAyMWw3LTEwLjVoLTVWMi41TDQgMTNoNXoiLz48L3N2Zz4=';
// Ícone "format_list_numbered" MDI pra InteractiveList — lista numerada (combina com UX da caixa).
const INTERACTIVE_LIST_ICON_SVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iIzMyMkE0OSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIj48cGF0aCBkPSJNNCAxN2gydi41SDV2MWgxVjE5SDR2MWgzdi00SDR2MXptMS05aDF2LTRINGwtMSAxLjV2LjVoMlY4em0tMSAzaDEuOGwtMS44IDJWMTVoM3YtMUg1LjJMNyAxMlYxMUg0djF6bTUtOXYyaDEydi0ySDl6bTAgMTRoMTJ2LTJIOXYyem0wLTZoMTJ2LTJIOXYyeiIvPjwvc3ZnPg==';

const SHAPE_SIZE = 48;

const FlowchartStart = dia.Element.define(ShapeTypesEnum.FLOWCHART_START, {
    name: 'FlowchartStart',
    size: { width: SHAPE_SIZE, height: SHAPE_SIZE },
    attrs: {
        body: {
            fill: MAIN_COLOR,
            stroke: 'none',
            cx: 'calc(0.5 * w)',
            cy: 'calc(0.5 * h)',
            r: 'calc(0.5 * w)',
        },
        icon: {
            d: 'M 2 8 L 4.29 5.71 L 1.41 2.83 L 2.83 1.41 L 5.71 4.29 L 8 2 L 8 8 Z M -2 8 L -8 8 L -8 2 L -5.71 4.29 L -1 -0.41 L -1 -8 L 1 -8 L 1 0.41 L -4.29 5.71 Z',
            fill: '#FFFFFF',
            transform: 'translate(calc(0.5 * w), calc(0.5 * h))'
        },
        label: {
            text: 'Start',
            x: `calc(w + ${PADDING_L})`,
            y: 'calc(0.5 * h)',
            textAnchor: 'start',
            textVerticalAnchor: 'middle',
            fill: '#242424',
            fontFamily: FONT_FAMILY,
            fontSize: 13
        }
    }
} as mvc.ObjectHash, {
    markup: [{
        tagName: 'circle',
        selector: 'body'
    }, {
        tagName: 'path',
        selector: 'icon'
    }, {
        tagName: 'text',
        selector: 'label'
    }],
});

const FlowchartEnd = dia.Element.define(ShapeTypesEnum.FLOWCHART_END, {
    name: 'FlowchartEnd',
    size: { width: SHAPE_SIZE, height: SHAPE_SIZE },
    attrs: {
        body: {
            fill: MAIN_COLOR,
            stroke: 'none',
            cx: 'calc(0.5 * w)',
            cy: 'calc(0.5 * h)',
            r: 'calc(0.5 * w)'
        },
        icon: {
            d: 'M 5 -8.45 L 6.41 -7.04 L 3 -3.635 L 1.59 -5.04 Z M -4.5 3.95 L -1 3.95 L -1 -1.63 L -6.41 -7.04 L -5 -8.45 L 1 -2.45 L 1 3.95 L 4.5 3.95 L 0 8.45 Z',
            fill: '#FFFFFF',
            transform: 'translate(calc(0.5 * w), calc(0.5 * h))'
        },
        label: {
            text: 'End',
            x: `calc(w + ${PADDING_L})`,
            y: 'calc(0.5 * h)',
            textAnchor: 'start',
            textVerticalAnchor: 'middle',
            fill: '#242424',
            fontFamily: FONT_FAMILY,
            fontSize: 13
        },
    }
} as mvc.ObjectHash, {
    markup: [{
        tagName: 'circle',
        selector: 'body'
    }, {
        tagName: 'path',
        selector: 'icon'
    }, {
        tagName: 'text',
        selector: 'label'
    }],
});

const Message = dia.Element.define(ShapeTypesEnum.MESSAGE, {
    name: 'Message',
    size: { width: SHAPE_SIZE, height: SHAPE_SIZE },
    attrs: {
        body: {
            fill: LIGHT_COLOR,
            stroke: '#E8E8E8',
            cx: 'calc(0.5 * w)',
            cy: 'calc(0.5 * h)',
            r: 'calc(0.5 * w)',
        },
        icon: {
            width: 20,
            height: 20,
            x: 'calc(0.5 * w - 10)',
            y: 'calc(0.5 * h - 10)',
            xlinkHref: MESSAGE_ICON
        },
        label: {
            text: 'Component',
            x: `calc(w + ${PADDING_L})`,
            y: 'calc(0.5 * h)',
            textAnchor: 'start',
            textVerticalAnchor: 'middle',
            fill: '#242424',
            fontFamily: FONT_FAMILY,
            fontSize: 13
        }
    }
} as mvc.ObjectHash, {
    markup: [{
        tagName: 'circle',
        selector: 'body'
    }, {
        tagName: 'image',
        selector: 'icon'
    }, {
        tagName: 'text',
        selector: 'label'
    }]
});

const ResponseOrientation = dia.Element.define(ShapeTypesEnum.RESPONSE_ORIENTATION, {
    name: 'ResponseOrientation',
    size: { width: SHAPE_SIZE, height: SHAPE_SIZE },
    attrs: {
        body: {
            fill: LIGHT_COLOR,
            stroke: '#E8E8E8',
            cx: 'calc(0.5 * w)',
            cy: 'calc(0.5 * h)',
            r: 'calc(0.5 * w)',
        },
        icon: {
            width: 20,
            height: 20,
            x: 'calc(0.5 * w - 10)',
            y: 'calc(0.5 * h - 10)',
            xlinkHref: MESSAGE_ICON
        },
        label: {
            text: 'Component',
            x: `calc(w + ${PADDING_L})`,
            y: 'calc(0.5 * h)',
            textAnchor: 'start',
            textVerticalAnchor: 'middle',
            fill: '#242424',
            fontFamily: FONT_FAMILY,
            fontSize: 13
        }
    }
} as mvc.ObjectHash, {
    markup: [{
        tagName: 'circle',
        selector: 'body'
    }, {
        tagName: 'image',
        selector: 'icon'
    }, {
        tagName: 'text',
        selector: 'label'
    }]
});

const TalkAttendant = dia.Element.define(ShapeTypesEnum.TALK_ATTENDANT, {
    name: 'TalkAttendant',
    size: { width: SHAPE_SIZE, height: SHAPE_SIZE },
    attrs: {
        body: {
            fill: LIGHT_COLOR,
            stroke: '#E8E8E8',
            cx: 'calc(0.5 * w)',
            cy: 'calc(0.5 * h)',
            r: 'calc(0.5 * w)',
        },
        icon: {
            width: 20,
            height: 20,
            x: 'calc(0.5 * w - 10)',
            y: 'calc(0.5 * h - 10)',
            xlinkHref: TALK_ATTENDANT_ICON
        },
        label: {
            text: 'Component',
            x: `calc(w + ${PADDING_L})`,
            y: 'calc(0.5 * h)',
            textAnchor: 'start',
            textVerticalAnchor: 'middle',
            fill: '#242424',
            fontFamily: FONT_FAMILY,
            fontSize: 13
        }
    }
} as mvc.ObjectHash, {
    markup: [{
        tagName: 'circle',
        selector: 'body'
    }, {
        tagName: 'image',
        selector: 'icon'
    }, {
        tagName: 'text',
        selector: 'label'
    }]
});

const ResponseParam = dia.Element.define(ShapeTypesEnum.RESPONSE_PARAM, {
    name: 'ResponseParam',
    size: { width: SHAPE_SIZE, height: SHAPE_SIZE },
    attrs: {
        body: {
            fill: LIGHT_COLOR,
            stroke: '#E8E8E8',
            cx: 'calc(0.5 * w)',
            cy: 'calc(0.5 * h)',
            r: 'calc(0.5 * w)',
        },
        icon: {
            width: 20,
            height: 20,
            x: 'calc(0.5 * w - 10)',
            y: 'calc(0.5 * h - 10)',
            xlinkHref: RESPONSE_PARAM_ICON
        },
        label: {
            text: 'Component',
            x: `calc(w + ${PADDING_L})`,
            y: 'calc(0.5 * h)',
            textAnchor: 'start',
            textVerticalAnchor: 'middle',
            fill: '#242424',
            fontFamily: FONT_FAMILY,
            fontSize: 13
        }
    }
} as mvc.ObjectHash, {
    markup: [{
        tagName: 'circle',
        selector: 'body'
    }, {
        tagName: 'image',
        selector: 'icon'
    }, {
        tagName: 'text',
        selector: 'label'
    }]
});

const Service = dia.Element.define(ShapeTypesEnum.SERVICE, {
    name: 'Service',
    size: { width: SHAPE_SIZE, height: SHAPE_SIZE },
    attrs: {
        body: {
            fill: LIGHT_COLOR,
            stroke: '#E8E8E8',
            cx: 'calc(0.5 * w)',
            cy: 'calc(0.5 * h)',
            r: 'calc(0.5 * w)',
        },
        icon: {
            width: 20,
            height: 20,
            x: 'calc(0.5 * w - 10)',
            y: 'calc(0.5 * h - 10)',
            xlinkHref: ENTITY_ICON
        },
        label: {
            text: 'Component',
            x: `calc(w + ${PADDING_L})`,
            y: 'calc(0.5 * h)',
            textAnchor: 'start',
            textVerticalAnchor: 'middle',
            fill: '#242424',
            fontFamily: FONT_FAMILY,
            fontSize: 13
        }
    }
} as mvc.ObjectHash, {
    markup: [{
        tagName: 'circle',
        selector: 'body'
    }, {
        tagName: 'image',
        selector: 'icon'
    }, {
        tagName: 'text',
        selector: 'label'
    }]
});

const CreateTicket = dia.Element.define(ShapeTypesEnum.CREATE_TICKET, {
    name: 'CreateTicket',
    size: { width: SHAPE_SIZE, height: SHAPE_SIZE },
    attrs: {
        body: {
            fill: LIGHT_COLOR,
            stroke: '#E8E8E8',
            cx: 'calc(0.5 * w)',
            cy: 'calc(0.5 * h)',
            r: 'calc(0.5 * w)',
        },
        icon: {
            width: 20,
            height: 20,
            x: 'calc(0.5 * w - 10)',
            y: 'calc(0.5 * h - 10)',
            xlinkHref: ENTITY_ICON
        },
        label: {
            text: 'Component',
            x: `calc(w + ${PADDING_L})`,
            y: 'calc(0.5 * h)',
            textAnchor: 'start',
            textVerticalAnchor: 'middle',
            fill: '#242424',
            fontFamily: FONT_FAMILY,
            fontSize: 13
        }
    }
} as mvc.ObjectHash, {
    markup: [{
        tagName: 'circle',
        selector: 'body'
    }, {
        tagName: 'image',
        selector: 'icon'
    }, {
        tagName: 'text',
        selector: 'label'
    }]
});

const Avaliation = dia.Element.define(ShapeTypesEnum.AVALIATION, {
    name: 'Avaliation',
    size: { width: SHAPE_SIZE, height: SHAPE_SIZE },
    attrs: {
        body: {
            fill: LIGHT_COLOR,
            stroke: '#E8E8E8',
            cx: 'calc(0.5 * w)',
            cy: 'calc(0.5 * h)',
            r: 'calc(0.5 * w)',
        },
        icon: {
            width: 20,
            height: 20,
            x: 'calc(0.5 * w - 10)',
            y: 'calc(0.5 * h - 10)',
            xlinkHref: ENTITY_ICON
        },
        label: {
            text: 'Component',
            x: `calc(w + ${PADDING_L})`,
            y: 'calc(0.5 * h)',
            textAnchor: 'start',
            textVerticalAnchor: 'middle',
            fill: '#242424',
            fontFamily: FONT_FAMILY,
            fontSize: 13
        }
    }
} as mvc.ObjectHash, {
    markup: [{
        tagName: 'circle',
        selector: 'body'
    }, {
        tagName: 'image',
        selector: 'icon'
    }, {
        tagName: 'text',
        selector: 'label'
    }]
});

const Flow = dia.Element.define(ShapeTypesEnum.FLOW, {
    name: 'Flow',
    size: { width: SHAPE_SIZE, height: SHAPE_SIZE },
    attrs: {
        body: {
            fill: LIGHT_COLOR,
            stroke: '#E8E8E8',
            cx: 'calc(0.5 * w)',
            cy: 'calc(0.5 * h)',
            r: 'calc(0.5 * w)',
        },
        icon: {
            width: 20,
            height: 20,
            x: 'calc(0.5 * w - 10)',
            y: 'calc(0.5 * h - 10)',
            xlinkHref: FLOW_ICON
        },
        label: {
            text: 'Component',
            x: `calc(w + ${PADDING_L})`,
            y: 'calc(0.5 * h)',
            textAnchor: 'start',
            textVerticalAnchor: 'middle',
            fill: '#242424',
            fontFamily: FONT_FAMILY,
            fontSize: 13
        }
    }
} as mvc.ObjectHash, {
    markup: [{
        tagName: 'circle',
        selector: 'body'
    }, {
        tagName: 'image',
        selector: 'icon'
    }, {
        tagName: 'text',
        selector: 'label'
    }]
});

const LLM = dia.Element.define(ShapeTypesEnum.LLM, {
    name: 'LLM',
    size: { width: SHAPE_SIZE, height: SHAPE_SIZE },
    attrs: {
        body: {
            fill: LIGHT_COLOR,
            stroke: '#E8E8E8',
            cx: 'calc(0.5 * w)',
            cy: 'calc(0.5 * h)',
            r: 'calc(0.5 * w)',
        },
        icon: {
            width: 20,
            height: 20,
            x: 'calc(0.5 * w - 10)',
            y: 'calc(0.5 * h - 10)',
            xlinkHref: LLM_ICON
        },
        label: {
            text: 'Component',
            x: `calc(w + ${PADDING_L})`,
            y: 'calc(0.5 * h)',
            textAnchor: 'start',
            textVerticalAnchor: 'middle',
            fill: '#242424',
            fontFamily: FONT_FAMILY,
            fontSize: 13
        }
    }
} as mvc.ObjectHash, {
    markup: [{
        tagName: 'circle',
        selector: 'body'
    }, {
        tagName: 'image',
        selector: 'icon'
    }, {
        tagName: 'text',
        selector: 'label'
    }]
});

const Condition = dia.Element.define(ShapeTypesEnum.CONDITION, {
    name: 'Condition',
    size: { width: SHAPE_SIZE, height: SHAPE_SIZE },
    attrs: {
        body: {
            fill: LIGHT_COLOR,
            stroke: '#E8E8E8',
            cx: 'calc(0.5 * w)',
            cy: 'calc(0.5 * h)',
            r: 'calc(0.5 * w)',
        },
        icon: {
            width: 20,
            height: 20,
            x: 'calc(0.5 * w - 10)',
            y: 'calc(0.5 * h - 10)',
            xlinkHref: LLM_ICON
        },
        label: {
            text: 'Component',
            x: `calc(w + ${PADDING_L})`,
            y: 'calc(0.5 * h)',
            textAnchor: 'start',
            textVerticalAnchor: 'middle',
            fill: '#242424',
            fontFamily: FONT_FAMILY,
            fontSize: 13
        }
    }
} as mvc.ObjectHash, {
    markup: [{
        tagName: 'circle',
        selector: 'body'
    }, {
        tagName: 'image',
        selector: 'icon'
    }, {
        tagName: 'text',
        selector: 'label'
    }]
});

// Item #1 roadmap chatbot JOINT (06/10/2026) — stencil draggable da caixa SetVariable.
// Formato visual circular padrão (mesma estrutura das demais caixas no stencil).
// Ao arrastar para o canvas, o Chatbot.ts converte stencil.SetVariable → app.SetVariable
// (shape operacional definido em app.shapes.ts com portas IN/OUT e config `operations`).
const SetVariable = dia.Element.define(ShapeTypesEnum.SET_VARIABLE, {
    name: 'SetVariable',
    size: { width: SHAPE_SIZE, height: SHAPE_SIZE },
    attrs: {
        body: {
            fill: LIGHT_COLOR,
            stroke: '#E8E8E8',
            cx: 'calc(0.5 * w)',
            cy: 'calc(0.5 * h)',
            r: 'calc(0.5 * w)',
        },
        icon: {
            width: 20,
            height: 20,
            x: 'calc(0.5 * w - 10)',
            y: 'calc(0.5 * h - 10)',
            // Ícone "settings/gear" MDI próprio — distinto do Condition (regra 07/10:
            // toda caixa nova tem ícone único). Bug fix 08/10: antes usava CONDITON_ICON.
            xlinkHref: SET_VARIABLE_ICON_SVG
        },
        label: {
            text: 'Set Variable',
            x: `calc(w + ${PADDING_L})`,
            y: 'calc(0.5 * h)',
            textAnchor: 'start',
            textVerticalAnchor: 'middle',
            fill: '#242424',
            fontFamily: FONT_FAMILY,
            fontSize: 13
        }
    }
} as mvc.ObjectHash, {
    markup: [{
        tagName: 'circle',
        selector: 'body'
    }, {
        tagName: 'image',
        selector: 'icon'
    }, {
        tagName: 'text',
        selector: 'label'
    }]
});

// Item #2 roadmap chatbot JOINT (07/10/2026) — stencil draggable da caixa Tag.
// Ícone de label/tag MDI (distinto do Condition e SetVariable).
const Tag = dia.Element.define(ShapeTypesEnum.TAG, {
    name: 'Tag',
    size: { width: SHAPE_SIZE, height: SHAPE_SIZE },
    attrs: {
        body: {
            fill: LIGHT_COLOR,
            stroke: '#E8E8E8',
            cx: 'calc(0.5 * w)',
            cy: 'calc(0.5 * h)',
            r: 'calc(0.5 * w)',
        },
        icon: {
            width: 20,
            height: 20,
            x: 'calc(0.5 * w - 10)',
            y: 'calc(0.5 * h - 10)',
            xlinkHref: TAG_ICON_SVG
        },
        label: {
            text: 'Tag',
            x: `calc(w + ${PADDING_L})`,
            y: 'calc(0.5 * h)',
            textAnchor: 'start',
            textVerticalAnchor: 'middle',
            fill: '#242424',
            fontFamily: FONT_FAMILY,
            fontSize: 13
        }
    }
} as mvc.ObjectHash, {
    markup: [{
        tagName: 'circle',
        selector: 'body'
    }, {
        tagName: 'image',
        selector: 'icon'
    }, {
        tagName: 'text',
        selector: 'label'
    }]
});

// Item #2 roadmap chatbot JOINT (07/10/2026) — stencil draggable da caixa Note.
// Ícone de nota/description MDI (distinto do Tag, SetVariable, Condition).
const Note = dia.Element.define(ShapeTypesEnum.NOTE, {
    name: 'Note',
    size: { width: SHAPE_SIZE, height: SHAPE_SIZE },
    attrs: {
        body: {
            fill: LIGHT_COLOR,
            stroke: '#E8E8E8',
            cx: 'calc(0.5 * w)',
            cy: 'calc(0.5 * h)',
            r: 'calc(0.5 * w)',
        },
        icon: {
            width: 20,
            height: 20,
            x: 'calc(0.5 * w - 10)',
            y: 'calc(0.5 * h - 10)',
            xlinkHref: NOTE_ICON_SVG
        },
        label: {
            text: 'Nota',
            x: `calc(w + ${PADDING_L})`,
            y: 'calc(0.5 * h)',
            textAnchor: 'start',
            textVerticalAnchor: 'middle',
            fill: '#242424',
            fontFamily: FONT_FAMILY,
            fontSize: 13
        }
    }
} as mvc.ObjectHash, {
    markup: [{
        tagName: 'circle',
        selector: 'body'
    }, {
        tagName: 'image',
        selector: 'icon'
    }, {
        tagName: 'text',
        selector: 'label'
    }]
});

// Item #3 roadmap chatbot JOINT (07/10/2026) — stencil draggable da caixa BusinessHours.
// Ícone de relógio MDI (distinto de Tag, Note, SetVariable, Condition).
const BusinessHours = dia.Element.define(ShapeTypesEnum.BUSINESS_HOURS, {
    name: 'BusinessHours',
    size: { width: SHAPE_SIZE, height: SHAPE_SIZE },
    attrs: {
        body: {
            fill: LIGHT_COLOR,
            stroke: '#E8E8E8',
            cx: 'calc(0.5 * w)',
            cy: 'calc(0.5 * h)',
            r: 'calc(0.5 * w)',
        },
        icon: {
            width: 20, height: 20,
            x: 'calc(0.5 * w - 10)',
            y: 'calc(0.5 * h - 10)',
            xlinkHref: BUSINESS_HOURS_ICON_SVG
        },
        label: {
            text: 'Horário',
            x: `calc(w + ${PADDING_L})`,
            y: 'calc(0.5 * h)',
            textAnchor: 'start',
            textVerticalAnchor: 'middle',
            fill: '#242424',
            fontFamily: FONT_FAMILY,
            fontSize: 13
        }
    }
} as mvc.ObjectHash, {
    markup: [{
        tagName: 'circle',
        selector: 'body'
    }, {
        tagName: 'image',
        selector: 'icon'
    }, {
        tagName: 'text',
        selector: 'label'
    }]
});

// Item #7 roadmap chatbot JOINT (08/10/2026) — stencil draggable da caixa NativeAction (YOLO).
// Ícone bolt (ação instantânea) distinto das outras.
const NativeAction = dia.Element.define(ShapeTypesEnum.NATIVE_ACTION, {
    name: 'NativeAction',
    size: { width: SHAPE_SIZE, height: SHAPE_SIZE },
    attrs: {
        body: {
            fill: LIGHT_COLOR,
            stroke: '#E8E8E8',
            cx: 'calc(0.5 * w)',
            cy: 'calc(0.5 * h)',
            r: 'calc(0.5 * w)',
        },
        icon: {
            width: 20, height: 20,
            x: 'calc(0.5 * w - 10)',
            y: 'calc(0.5 * h - 10)',
            xlinkHref: NATIVE_ACTION_ICON_SVG
        },
        label: {
            text: 'Ação Nativa',
            x: `calc(w + ${PADDING_L})`,
            y: 'calc(0.5 * h)',
            textAnchor: 'start',
            textVerticalAnchor: 'middle',
            fill: '#242424',
            fontFamily: FONT_FAMILY,
            fontSize: 13
        }
    }
} as mvc.ObjectHash, {
    markup: [
        { tagName: 'circle', selector: 'body' },
        { tagName: 'image', selector: 'icon' },
        { tagName: 'text', selector: 'label' }
    ]
});

// Item #7 Fase 2 (08/10/2026) — stencil da caixa InteractiveList (pausável).
const InteractiveList = dia.Element.define(ShapeTypesEnum.INTERACTIVE_LIST, {
    name: 'InteractiveList',
    size: { width: SHAPE_SIZE, height: SHAPE_SIZE },
    attrs: {
        body: {
            fill: LIGHT_COLOR,
            stroke: '#E8E8E8',
            cx: 'calc(0.5 * w)',
            cy: 'calc(0.5 * h)',
            r: 'calc(0.5 * w)',
        },
        icon: {
            width: 20, height: 20,
            x: 'calc(0.5 * w - 10)',
            y: 'calc(0.5 * h - 10)',
            xlinkHref: INTERACTIVE_LIST_ICON_SVG
        },
        label: {
            text: 'Lista Interativa',
            x: `calc(w + ${PADDING_L})`,
            y: 'calc(0.5 * h)',
            textAnchor: 'start',
            textVerticalAnchor: 'middle',
            fill: '#242424',
            fontFamily: FONT_FAMILY,
            fontSize: 13
        }
    }
} as mvc.ObjectHash, {
    markup: [
        { tagName: 'circle', selector: 'body' },
        { tagName: 'image', selector: 'icon' },
        { tagName: 'text', selector: 'label' }
    ]
});

Object.assign(shapes, {
    stencil: {
        Message,
        FlowchartStart,
        FlowchartEnd,
        ResponseOrientation,
        TalkAttendant,
        ResponseParam,
        Service,
        Flow,
        CreateTicket,
        Avaliation,
        LLM,
        Condition,
        SetVariable,
        Tag,
        Note,
        BusinessHours,
        NativeAction,
        InteractiveList
    }
});
